import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPredictionsLength } from "api/predictions.api";
import { getPromisesLength } from "api/promises.api";
import { getPredictorsLength } from "api/predictors.api";
import { getSurveysLength } from "api/surveys.api";

export const getPredictionsLengthAsync = createAsyncThunk(
  "dashboard/get-predictions-length",
  async () => {
    const length = await getPredictionsLength();
    return length;
  },
);

export const getPromisesLengthAsync = createAsyncThunk(
  "dashboard/get-promises-length",
  async () => {
    const length = await getPromisesLength();
    return length;
  },
);

export const getPredictorsLengthAsync = createAsyncThunk(
  "dashboard/get-predictors-length",
  async () => {
    const length = await getPredictorsLength();
    return length;
  },
);

export const getSurveysLengthAsync = createAsyncThunk(
  "dashboard/get-surveys-length",
  async () => {
    const length = await getSurveysLength();
    return length;
  },
);
